import { bind, state } from "@react-rxjs/core"
import { createSignal } from "@react-rxjs/utils"
import { distinctUntilChanged, map, scan } from "rxjs/operators"

export type TearOutSectionEntry = [boolean, Section, number?, number?]

type tornOutSize = { width: number; height: number }

export enum SectionName {
  Tiles = "tiles",
  FxBlotter = "blotter",
  Analytics = "analytics",
  NewRfq = "newRfq",
  CreditBlotter = "creditBlotter",
}

export const ALL_SECTIONS = Object.values(SectionName)

export type Section = SectionName

type SectionConfig = { [section in Section]: tornOutSize }

export const [tearOutSectionEntry$, tearOutSection] = createSignal(
  (
    bool: boolean,
    section: Section,
    width?: number,
    height?: number,
  ): TearOutSectionEntry => [bool, section, width, height],
)

const INITIAL: Record<Section, boolean> = {
  [SectionName.Tiles]: false,
  [SectionName.FxBlotter]: false,
  [SectionName.Analytics]: false,
  [SectionName.NewRfq]: false,
  [SectionName.CreditBlotter]: false,
}

export const tornOutSections$ = state(
  tearOutSectionEntry$.pipe(
    scan(
      (acc, [tornOut, section]) => ({ ...acc, [section]: tornOut }),
      INITIAL,
    ),
  ),
  INITIAL,
)

export const [useIsTornOut] = bind((section: Section) =>
  tornOutSections$.pipe(
    map((sections) => sections[section]),
    distinctUntilChanged(),
  ),
)

export const sectionConfig: SectionConfig = {
  [SectionName.FxBlotter]: {
    width: window.innerWidth - window.innerWidth * 0.15,
    height: window.innerHeight - window.innerHeight * 0.5,
  },
  [SectionName.Tiles]: {
    width: window.innerWidth - window.innerWidth * 0.15,
    height: window.innerHeight - window.innerHeight * 0.5,
  },
  [SectionName.Analytics]: {
    width: window.innerWidth - window.innerWidth * 0.7,
    height: window.innerHeight * 0.52,
  },
  [SectionName.NewRfq]: {
    width: window.innerWidth - window.innerWidth * 0.7,
    height: window.innerHeight,
  },
  [SectionName.CreditBlotter]: {
    width: window.innerWidth - window.innerWidth * 0.15,
    height: window.innerHeight - window.innerHeight * 0.5,
  },
}
